import {
  useIntegrationTrackingStore,
  type IntegrationPayload
} from "../store/integrationTracking.store";

/**
 * Hook to get integration waiting state for a workflow's steps
 * Replaces: useSelector(state => state.workflowDetails[processId].stepsWaiting)
 */
export const useTaskWaiting = (processId?: number) => {
  const getStepsWaiting = useIntegrationTrackingStore(
    state => state.getStepsWaiting
  );

  if (!processId) {
    return {};
  }

  return getStepsWaiting(processId);
};

/**
 * Hook to set integration pending state
 * Replaces: dispatch(workflowDetailsActions.setStepIntegrationPending(...))
 */
export const useSetStepIntegrationPending = () => {
  const setStepIntegrationPending = useIntegrationTrackingStore(
    state => state.setStepIntegrationPending
  );

  return (payload: IntegrationPayload) => {
    setStepIntegrationPending(payload);
  };
};

/**
 * Hook to set integration finished state
 * Replaces: dispatch(workflowDetailsActions.setStepIntegrationFinished(...))
 */
export const useSetStepIntegrationFinished = () => {
  const setStepIntegrationFinished = useIntegrationTrackingStore(
    state => state.setStepIntegrationFinished
  );

  return (payload: IntegrationPayload) => {
    setStepIntegrationFinished(payload);
  };
};
